import React from "react";
import WD_Project_1 from "./web_development/WD_Project_1";
import WD_Project_2 from "./web_development/WD_Project_2";
import WD_Project_3 from "./web_development/WD_Project_3";
import WD_Project_4 from "./web_development/WD_Project_4";
import WD_Project_5 from "./web_development/WD_Project_5";

const WebDevelopment = () => {
  return (
    <div className="image-box-wrapper row justify-content-center">
      <WD_Project_1 />
      <WD_Project_2 />
      <WD_Project_3 />
      <WD_Project_4 />
      <WD_Project_5 />
    </div>
  );
};

export default WebDevelopment;
